import type { EventType } from 'entities/events'
import type { TableStandings } from 'entities/competitions'
import type { SportStatus } from 'entities/disciplines'

export interface Translation {
    language: string
}

export interface SportPosition {
    id: number
    name: string
    shortName: string
    defaultX: number
    defaultY: number
    sportId: string
}

export interface SportFormation {
    id: number
    name: string
    sportId: string
}

export interface SportDiscipline {
    id: string
    name: string
    status: string
    sex: string[]
    type: string
    measurement: string
    createdAt: string
    updatedAt: string
    sportId: string
}

export interface Sport {
    id: string
    name: string
    hasSets: boolean
    hasGames: boolean
    hasExtensions: boolean
    hasPenalties: boolean
    hasCaptain: boolean
    hasJerseys: boolean
    numberOfPeriods: number
    periodsName: string
    statistics: string[]
    pointsAwardSystem: string
    status: SportStatus
    pointsForWin: number
    pointsForDraw: number
    pointsForLoss: number
    type: SportTypesValue[]
    fieldImageKey: string
    createdAt: string
    updatedAt: string
    translations: Translation[]
    sportEvents: EventType[]
    groupTableColumns: string[]
    // Extended fields returned by detail endpoints
    groupTableColumn?: string[]
    positions?: SportPosition[]
    formations?: SportFormation[]
    disciplines?: SportDiscipline[]
}

export enum SportTypesLabel {
    INDIVIDUAL = 'Individualni',
    TEAM = 'Ekipni',
    MIXED = 'Ekipno - individualni',
}
export enum PhaseParticipantTypeLabel {
    INDIVIDUAL = 'Individualni',
    TEAM = 'Ekipni',
    TEAM_INDIVIDUAL = 'Ekipno-individualni',
}
export enum PhaseParticipantType {
    INDIVIDUAL = 'individual',
    TEAM = 'team',
    TEAM_INDIVIDUAL = 'team-individual',
}

export enum SportTypesValue {
    INDIVIDUAL = 'individual',
    TEAM = 'team',
    MIXED = 'team-individual',
}

export type RequestSportGenerateUploadURL = {
    sportId: string
    key?: string
}
export interface SportTypeOption {
    id: number
    value: string
    label: string
}

export interface SportFormType {
    name: string
    shortName: string
    email: string
    status: SportStatus
    address: string
    country: string
    place: string
    dateOfEstablishment: string
    contactNumber: string
    imageKey: string
    type: SportTypeOption[]
    pointsForWin: number
    pointsForDraw: number
    pointsForLoss: number
    hasPenalties: boolean
    hasExtensions: boolean
    hasDivisions: boolean
    hasSets: boolean
    fieldImageKey: string
    numberOfDivisions: number
    periodsName: string
    file: File
    hasCaptain: boolean
    hasJerseys: boolean
    areaShow: boolean
    groupTableColumn: string
    pointsAwardSystem: TableStandings
    hasGames: boolean
}
